import * as types from './constants';

// Get Lookbooks
export const getLookbooksRequest = data => (
  { type: types.GET_LOOKBOOKS_REQUEST, payload: data }
);

export const getLookbooksDone = data => (
  { type: types.GET_LOOKBOOKS_DONE, payload: data }
);

export const getLookbooksFailed = errors => (
  { type: types.GET_LOOKBOOKS_FAILED, payload: errors }
);

export const getLookbooksReset = () => (
  { type: types.GET_LOOKBOOKS_RESET }
);

// Operations
export const toggleLookbook = data => (
  { type: types.TOGGLE_LOOKBOOK, payload: data }
);

export const toggleAllLookbooks = data => (
  { type: types.TOGGLE_ALL_LOOKBOOKS, payload: data }
);

export const setFilter = data => (
  { type: types.SET_LOOKBOOKS_FILTER, payload: data }
);

export const setAllFilters = data => (
  { type: types.SET_LOOKBOOKS_ALL_FILTERS, payload: data }
);

export const clearFilters = (filterToUpdate, mobile) => (
  { type: types.CLEAR_LOOKBOOKS_FILTERS, payload: { filterToUpdate, mobile } }
);

export const lookbooksSetPage = data => (
  { type: types.LOOKBOOKS_SET_PAGE, payload: data }
);